@if (widget; as current) {
  <div class="adx-widget-window" (mouseenter)="onHover(true)" (mouseleave)="onHover(false)">
    @if (renderWidgetHeader(current)) {
      <app-widget-header class="adx-widget-window-header"
        [ngClass]="{
          'always-displayed': current.appPluginWidget.settings.widgetHeader.alwaysDisplayed,
          'hover-displayed': current.appPluginWidget.settings.widgetHeader.onHoverDisplayed,
          'adx-header-shown': widgetHeaderIsHovered(current)
        }"
        [widget]="current"
        variant="window"
        [isFullscreen]="isFullscreen"
        [canToggleFullscreen]="true"
        [canOpenSettings]="canOpenSettings(current)"
        [canCloseWindow]="true"
        (fullscreenToggle)="toggleFullscreen()"
        (settingsOpen)="openSettings(current)"
        (closeWindow)="closeWindow()"
        (menuOpenChange)="onMenuOpenChange($event)">
      </app-widget-header>
    }
    @if (showWidgetDivider(current)) {
      <mat-divider></mat-divider>
    }
    <div class="adx-widget-window-content"
      [class.adx-header-hover-mode]="current.appPluginWidget.settings.widgetHeader.onHoverDisplayed"
      [class.adx-header-overlaid]="widgetHeaderIsHovered(current)">
      <ng-template [appWidgetItem]="current" [isHeaderHovered]="widgetHeaderIsHovered(current)"></ng-template>
    </div>
  </div>
} @else if (state === "not-found") {
  <div class="adx-widget-window-message">
    <p>{{ "APP.WIDGET_WINDOW_NOT_FOUND" | translate }}</p>
    <button mat-flat-button (click)="closeWindow()">{{ "CLOSE" | translate }}</button>
  </div>
}
